import { render, staticRenderFns } from "./DocFormatConversion.vue?vue&type=template&id=6247fb2c&scoped=true&"
import script from "./DocFormatConversion.vue?vue&type=script&lang=ts&"
export * from "./DocFormatConversion.vue?vue&type=script&lang=ts&"
import style0 from "./DocFormatConversion.vue?vue&type=style&index=0&id=6247fb2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6247fb2c",
  null
  
)

export default component.exports